<template>
  <div class="cellBox">
    <div v-for="(el,index) in colList" :key="index" class="colBox">
      <span class="cellTitle">{{ el.title }}：</span>
      <span class="cellContent">
        <span v-if="el.field == 'area'">
          {{detail.province}} {{ detail.city }} {{ detail.area }}
        </span>
        <span v-else-if="el.field == 'farmScale'">
          {{detail.farmScale?.toFixed(2)}}
        </span>
        <span v-else-if="el.field == 'feedPrice'">
          {{detail.feedPrice?.toFixed(2)}}
        </span>
        <a v-else-if="el.field == 'productName' && detail.nhfFormulaId" @click="() => productDetail()">
          {{ detail.productName }}
        </a>
        <span v-else>          
          {{ detail[el.field] || detail[el.field] === 0 ? (Number(detail[el.field]) || Number(detail[el.field]) === 0 ? (len ? Number(detail[el.field]).toFixed(len) : detail[el.field]) : detail[el.field]) : '' }}
        </span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['colList','detail','len'],
  methods: {
    productDetail(){
      this.$http.get(`/nhf-app/api/sat/collect/formula/actions/check?formulaId=${this.detail.nhfFormulaId}`).then(res => {
        if(res.code == 200){
          this.$router.push({
            path: '/nhf-compound-editor',
            query: {
              id: this.detail.nhfFormulaId
            }
          })
        }
      })
    },
  },
}
</script>